import React from 'react';
import { FaEdit } from 'react-icons/fa';
import { BsPersonLinesFill } from 'react-icons/bs';
import { GoChecklist } from 'react-icons/go';
import { CgNotes } from 'react-icons/cg';
import { GoGraph } from 'react-icons/go';
import { useHistory, useLocation } from 'react-router-dom';
import { useLocalStorage } from '../../../contexts/LocalStorage';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuIcon from '@material-ui/icons/Menu';
import LogoPedidosForce from '../../assets/pedidos_fc.png';
import IconButton from '@material-ui/core/IconButton';
import Grow from '@material-ui/core/Grow';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import GaVertical from '../../assets/logo-ga-min.png';
import LogoADA from '../../assets/pedidos-force-square-logo.png';
import { useAuth } from '../../../contexts/Auth';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
//icones do menu

export function Sidebar() {
    let history = useHistory();
    let location = useLocation();
    const { getFromLocalStorage, saveInLocalStorage } = useLocalStorage();
    const { user } = useAuth();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [expanded, setExpanded] = React.useState<string | false>(false);
    const [expandedSidebar, setExpandedSidebar] = React.useState<boolean>(getFromLocalStorage("sidebar_expanded") === "true" ? true : false);
    const [popPedido, setPopPedido] = React.useState<boolean>(false);
    const [popCliente, setPopCliente] = React.useState<boolean>(false);
    const [popAprovacao, setPopAprovacao] = React.useState<boolean>(false);
    const [popRelatorio, setPopRelatorio] = React.useState<boolean>(false);

    const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setPopPedido(false);
        setPopCliente(false);
        setPopAprovacao(false);
        setPopRelatorio(false);
    };

    const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        switch (event.currentTarget.getAttribute("aria-controls")) {
            case "pedidos-sidebar-min":
                setPopPedido(true);
                break;
            case "clientes-sidebar-min":
                setPopCliente(true);
                break;
            case "aprovacao-sidebar-min":
                setPopAprovacao(true);
                break;
            case "relatorios-sidebar-min":
                setPopRelatorio(true);
                break;
            case "dashboard-sidebar-min":
                redirectTo("/dashboard");
                break;
            default:
                break;
        }
    };

    const handleChangeSidebar = () => {
        setExpandedSidebar(!expandedSidebar);
        saveInLocalStorage("sidebar_expanded", (!expandedSidebar).toString());
    };

    function redirectTo(path: string) {
        //window.location.reload();
        if(location.pathname === path){
            window.location.reload();
        }else{
            history.push(process.env.PUBLIC_URL + path);
        }
    }

    return (
        <div className={expandedSidebar ? "sidebar" : "sidebar-min"}>
            <div>
                <div className={expandedSidebar ? "salesforce-logo-area" : "salesforce-logo-area-min"}>
                    <div></div>
                    <img src={LogoPedidosForce} onClick={() => redirectTo("/inicio")} alt="Logo Pedidos Force" style={{ width: '52%', height: '90%', cursor: 'pointer' }} className={expandedSidebar ? "img-logo-top" : "img-logo-top-min"} />
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={() => handleChangeSidebar()}
                        className="btn-menu-sidebar"
                    >
                        <MenuIcon />
                    </IconButton>
                </div>
                {expandedSidebar ?
                    <Grow
                        in={expandedSidebar}
                        style={{ transformOrigin: '0 0 0' }}
                        {...(expandedSidebar ? { timeout: 1000 } : {})}
                    >

                        <div className="root-sidebar">
                            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} className="sidebar-item">
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1bh-content"
                                    id="panel1bh-header"
                                >
                                    <Typography className="secondaryHeading"><FaEdit className="color-sidebar" size="2em" /></Typography>
                                    <Typography className="heading">Pedidos</Typography>
                                </AccordionSummary>
                                <AccordionDetails className="option-sidebar">
                                    <button onClick={() => redirectTo("/pedidos/novo")}>
                                        Novo Pedido
                                    </button>
                                    <button onClick={() => redirectTo("/pedidos/consultar")}>
                                        Consultar Pedidos
                                    </button>
                                    <button onClick={() => redirectTo("/prepedidos/consultar")}>
                                        Consultar Pré-Pedidos
                                    </button>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')} className="sidebar-item">
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2bh-content"
                                    id="panel2bh-header"
                                >
                                    <Typography className="secondaryHeading"><BsPersonLinesFill className="color-sidebar" size="2em" /></Typography>
                                    <Typography className="heading">Clientes</Typography>
                                </AccordionSummary>
                                <AccordionDetails className="option-sidebar">
                                    <button onClick={() => redirectTo("/clientes/novo")}>
                                        Novo Cliente
                                    </button>
                                    <button onClick={() => redirectTo("/clientes/consultar")}>
                                        Consultar Clientes
                                    </button>
                                </AccordionDetails>
                            </Accordion>
                            {user?.role === "RSU" &&
                                <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')} className="sidebar-item">
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel3bh-content"
                                        id="panel3bh-header"
                                    >
                                        <Typography className="secondaryHeading"><GoChecklist className="color-sidebar" size="2em" /></Typography>
                                        <Typography className="heading">Aprovação</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className="option-sidebar">
                                        <button onClick={() => redirectTo("/aprovacao")}>
                                            Aprovar Pedidos
                                        </button>
                                    </AccordionDetails>
                                </Accordion>
                            }
                            <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')} className="sidebar-item">
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel4bh-content"
                                    id="panel4bh-header"
                                >
                                    <Typography className="secondaryHeading"><CgNotes className="color-sidebar" size="2em" /></Typography>
                                    <Typography className="heading">Relatórios</Typography>
                                </AccordionSummary>
                                <AccordionDetails className="option-sidebar">
                                    <div className="menus-relatorios">
                                        <Typography className="titulo-sidebar-relatorios">Pedidos</Typography>
                                        <button onClick={() => redirectTo(`/relatorios/pedidos/RVPE461`)}>
                                            RVPE461 - Pedidos por Produto e Container
                                        </button>
                                        <button onClick={() => redirectTo(`/relatorios/pedidos/RVPE620`)}>
                                            RVPE620 - Tabela de Preço - Representante
                                        </button>
                                        <button onClick={() => redirectTo(`/relatorios/pedidos/RVPE571`)}>
                                            RVPE571 - Pedidos em Carteira ou Container
                                        </button>
                                        <button onClick={() => redirectTo(`/relatorios/pedidos/RVPE558`)}>
                                            RVPE558 - Romaneio para Conferencia
                                        </button>
                                        <Typography className="titulo-sidebar-relatorios">Faturamento</Typography>
                                        <button onClick={() => redirectTo(`/relatorios/faturamento/RFNF520`)}>
                                            RFNF520 - Comissão por Representante
                                        </button>
                                        <Typography className="titulo-sidebar-relatorios">Estoque</Typography>
                                        <button onClick={() => redirectTo(`/relatorios/estoque/SECE500`)}>
                                            SECE500 - Posição de Estoque - Unificada
                                        </button>
                                        <button onClick={() => redirectTo(`/relatorios/estoque/PANT001`)}>
                                            PANT001 - Posição de Estoque - Cores
                                        </button>
                                        <Typography className="titulo-sidebar-relatorios">Cadastros</Typography>
                                        <button onClick={() => redirectTo(`/relatorios/cadastros/DSCF208`)}>
                                            DSCF208 - Limite de Crédito por Grupo de Empresas
                                        </button>
                                        <Typography className="titulo-sidebar-relatorios">Financeiro</Typography>
                                        <button onClick={() => redirectTo(`/relatorios/financeiro/FRCR898`)}>
                                            FRCR898 - Titulos em Aberto
                                        </button>
                                    </div>
                                    <div className="icon-more-menu-relatorios">
                                        <KeyboardArrowDownIcon />
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion expanded={false} className="sidebar-item">
                                <AccordionSummary
                                    expandIcon={<></>}
                                    aria-controls="panel0bh-content"
                                    id="panel0bh-header"
                                    onClick={() => redirectTo("/dashboard")}
                                >
                                    <Typography className="secondaryHeading"><GoGraph className="color-sidebar" size="2em" /></Typography>
                                    <Typography className="heading">Dashboard</Typography>
                                </AccordionSummary>
                            </Accordion>
                        </div>
                    </Grow>
                    :
                    <Grow
                        in={!expandedSidebar}
                        style={{ transformOrigin: '0 0 0' }}
                        {...(!expandedSidebar ? { timeout: 1000 } : {})}
                    >
                        <div className="root-sidebar">
                            <div className="sidebar-item-min">
                                <IconButton
                                    edge="end"
                                    aria-label="Opção de Pedidos"
                                    aria-controls={"pedidos-sidebar-min"}
                                    aria-haspopup="true"
                                    onClick={handleProfileMenuOpen}
                                    color="inherit"
                                    style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}
                                >
                                    <FaEdit className="color-sidebar" size="1em" />
                                </IconButton>
                                <Menu
                                    anchorEl={anchorEl}
                                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    id={"pedidos-sidebar-min"}
                                    keepMounted
                                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    open={popPedido}
                                    onClose={handleClose}
                                >
                                    <MenuItem onClick={() => redirectTo("/pedidos/novo")}>Novo Pedido</MenuItem>
                                    <MenuItem onClick={() => redirectTo("/pedidos/consultar")}>Consultar Pedidos</MenuItem>
                                    <MenuItem onClick={() => redirectTo("/prepedidos/consultar")}>Consultar Pré-Pedidos</MenuItem>
                                </Menu>
                            </div>
                            <div className="sidebar-item-min">
                                <IconButton
                                    edge="end"
                                    aria-label="Opção de Clientes"
                                    aria-controls={"clientes-sidebar-min"}
                                    aria-haspopup="true"
                                    onClick={handleProfileMenuOpen}
                                    color="inherit"
                                    style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}
                                >
                                    <BsPersonLinesFill className="color-sidebar" size="1em" />
                                </IconButton>
                                <Menu
                                    anchorEl={anchorEl}
                                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    id={"clientes-sidebar-min"}
                                    keepMounted
                                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    open={popCliente}
                                    onClose={handleClose}
                                >
                                    <MenuItem onClick={() => redirectTo("/clientes/novo")}>Novo Cliente</MenuItem>
                                    <MenuItem onClick={() => redirectTo("/clientes/consultar")}>Consultar Clientes</MenuItem>
                                </Menu>
                            </div>
                            {user?.role === "RSU" &&
                                <div className="sidebar-item-min">
                                    <IconButton
                                        edge="end"
                                        aria-label="Opção de Aprovação"
                                        aria-controls={"aprovacao-sidebar-min"}
                                        aria-haspopup="true"
                                        onClick={handleProfileMenuOpen}
                                        color="inherit"
                                        style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}
                                    >
                                        <GoChecklist className="color-sidebar" size="1em" />
                                    </IconButton>
                                    <Menu
                                        anchorEl={anchorEl}
                                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                        id={"aprovacao-sidebar-min"}
                                        keepMounted
                                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                        open={popAprovacao}
                                        onClose={handleClose}
                                    >
                                        <MenuItem onClick={() => redirectTo("/aprovacao")}>Aprovar Pedidos</MenuItem>
                                    </Menu>
                                </div>
                            }
                            <div className="sidebar-item-min">
                                <IconButton
                                    edge="end"
                                    aria-label="Opção de Relatórios"
                                    aria-controls={"relatorios-sidebar-min"}
                                    aria-haspopup="true"
                                    onClick={handleProfileMenuOpen}
                                    color="inherit"
                                    style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}
                                >
                                    <CgNotes className="color-sidebar" size="1em" />
                                </IconButton>
                                <Menu
                                    anchorEl={anchorEl}
                                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    id={"relatorios-sidebar-min"}
                                    keepMounted
                                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    open={popRelatorio}
                                    onClose={handleClose}
                                >
                                    <Typography className="titulo-sidebar-min-relatorios">Pedidos</Typography>
                                    <MenuItem onClick={() => redirectTo(`/relatorios/pedidos/RVPE461`)}>RVPE461 - Pedidos por Produto e Container</MenuItem>
                                    <MenuItem onClick={() => redirectTo(`/relatorios/pedidos/RVPE620`)}>RVPE620 - Tabela de Preço - Representante</MenuItem>
                                    <MenuItem onClick={() => redirectTo(`/relatorios/pedidos/RVPE571`)}>RVPE571 - Pedidos em Carteira ou Container</MenuItem>
                                    <MenuItem onClick={() => redirectTo(`/relatorios/pedidos/RVPE558`)}>RVPE558 - Romaneio para Conferencia</MenuItem>

                                    <Typography className="titulo-sidebar-min-relatorios">Faturamento</Typography>
                                    <MenuItem onClick={() => redirectTo(`/relatorios/faturamento/RFNF520`)}>RFNF520 - Comissão por Representante</MenuItem>

                                    <Typography className="titulo-sidebar-min-relatorios">Estoque</Typography>
                                    <MenuItem onClick={() => redirectTo(`/relatorios/estoque/SECE500`)}>SECE500 - Disponibilidade de Estoque - Unificada</MenuItem>
                                    <MenuItem onClick={() => redirectTo(`/relatorios/estoque/PANT001`)}>PANT001 - Disponibilidade de Estoque - Cores</MenuItem>

                                    <Typography className="titulo-sidebar-min-relatorios">Cadastros</Typography>
                                    <MenuItem onClick={() => redirectTo(`/relatorios/cadastros/DSCF208`)}>DSCF208 - Limite de Crédito por Grupo de Empresas</MenuItem>

                                    <Typography className="titulo-sidebar-min-relatorios">Financeiro</Typography>
                                    <MenuItem onClick={() => redirectTo(`/relatorios/financeiro/FRCR898`)}>FRCR898 - Titulos em Aberto</MenuItem>
                                </Menu>
                            </div>
                            <div className="sidebar-item-min">
                                <IconButton
                                    edge="end"
                                    aria-label="Dashboard"
                                    aria-controls={"dashboard-sidebar-min"}
                                    aria-haspopup="true"
                                    onClick={handleProfileMenuOpen}
                                    color="inherit"
                                >
                                    <GoGraph className="color-sidebar" size="1em" />
                                </IconButton>
                            </div>
                        </div>
                    </Grow>
                }
            </div>
            <div>
                <div className='log-cliente-sidebar'>
                    {expandedSidebar ? <></> : <img src={LogoADA} onClick={() => redirectTo("/inicio")} alt="Logo Codapta" style={{ width: '80%', opacity: '1', marginBottom: '0.5em', borderRadius: '0.2em', cursor: 'pointer' }} />}
                    {/*expandedSidebar ? <></> : <img src={GaVertical} alt="Logo Geraldo Araújo" style={{ width: '80%', opacity: '1', borderRadius: '0.2em', padding: '0.4em 0 0.3em 0', backgroundColor: 'white', cursor: 'pointer' }} />*/}
                    {/* <img src={GaHorizontal} alt="Logo Geraldo Araújo" style={{ width: '95%', opacity: '0.3', borderRadius: '0.2em', padding: '0.4em 0 0.3em 0', backgroundColor: 'white' }} /> */}
                </div>
            </div>
        </div>
    );
}
